import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

import Authenticated from '../Authenticated';
import FirebaseLogin from '../FirebaseLogin';

import Styled from './styles';

import { init } from '../../reducers/auth';

class App extends Component {
  static propTypes = {
    initializing: PropTypes.bool,
    loggingOut: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    init: PropTypes.func
  };

  componentDidMount() {
    this.props.init();
  }

  render() {
    const { initializing, loggingOut, isLoggedIn } = this.props;

    if (initializing || loggingOut) {
      return (
        <Styled.Container>
          <CircularProgress color="primary" size={40} thickness={5} />
        </Styled.Container>
      );
    }

    return <div>{isLoggedIn ? <Authenticated /> : <FirebaseLogin />}</div>;
  }
}

const mapStateToProps = state => ({
  initializing: state.auth.initializing,
  loggingOut: state.auth.loggingOut,
  isLoggedIn: state.auth.isLoggedIn
});

const mapDispatchToProps = dispatch => ({
  init: (...params) => dispatch(init(...params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/pages/App/index.js